import styles from "./load-screen.module.scss";

import logo from "../../assets/logo-black.svg";

const LoadScreen = () => {
    return (
        <div className={styles.load_screen}>
            <div className={styles.logo_wrapper}>
                <img
                    className={styles.logo_img}
                    src={logo}
                    width={300}
                    height={300}
                    alt="Generation Marketing"
                />
            </div>
        </div>
    );
};

export default LoadScreen;
